import { GlobalResponseObject } from "../../global-response-object";
import { RevenueDetailsByCategoryDetails } from "./revenueDetailsByCategory-details";


export class RevenueDetailsByCategoryResponse extends GlobalResponseObject{
data?:RevenueDetailsByCategoryDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:RevenueDetailsByCategoryDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}